document.addEventListener("DOMContentLoaded", () => {
  const labels = document.querySelectorAll(".accordion-item__label");
  const tabs = document.querySelectorAll(".accordion-tab");
  
  labels.forEach((label) => label.addEventListener("click", toggleShow));
  tabs.forEach((tab) => tab.addEventListener("click", toggleShow));

  
  function toggleShow(event) {
    event.preventDefault(); // Prevent default behavior if needed

    const target = this;
    const item = target.classList.contains("accordion-tab")
        ? target
        : target.parentElement;

    if (!item) {
        console.warn("Item not found!", target);
        return;
    }

    const group = item.dataset.actabGroup;
    const id = item.dataset.actabId;

    if (!group || !id) {
        console.warn("Missing dataset attributes!", item);
        return;
    }

    // Toggle tabs
    tabs.forEach((tab) => {
      if (tab.dataset.actabGroup === group) {
        tab.classList.toggle("accordion-active", tab.dataset.actabId === id);
      }
    });

    // Toggle labels
    labels.forEach((label) => {
      const tabItem = label.parentElement;

      if (!tabItem) {
        console.warn("Parent element missing for", label);
        return;
      }

      if (tabItem.dataset.actabGroup === group) {
        tabItem.classList.toggle("accordion-active", tabItem.dataset.actabId === id);

        // Handle image change
        let imgSrc = tabItem.getAttribute("data-img_src");
        if (tabItem.classList.contains('accordion-active')) {          
          if (imgSrc && window.jQuery) {
            $(".product__images .image__container").html(
              `<img src="${imgSrc}" class="blur-up lazyautosizes lazyloaded">`
            );
          }
        }
      }
    });
  }
});


$(document).on('click','.accordion-item__label',function(){
  var position = $($(this)).offset().top - 120;

	$("body, html").animate({
		scrollTop: position
	} /* speed */ ); 
});

$(document).on('click','.accordion-tabs .modalButton',function(){    
  $('.bilderSlider').flickity('resize'); 
});

$(document).ready(function () {  
  
  var imgSrc = $('.product-serie .accordion-content .accordion-active').attr('data-img_src');
  if(imgSrc){
    $('.product__images .gallery-cell .image__container img').remove();
    $('.product__images .gallery-cell .image__container').html('<img src="'+imgSrc+'" class="blur-up lazyautosizes lazyloaded">');
  }
  
  $('.accordion-content .accordion-tabs .accordion-tab').each(function(){
    var accordianData = $(this).attr('data-actab-group');
    var a = $('[data-actab-group="'+accordianData+'"].accordion-tab').length;
    if(a == 1){
      $('[data-actab-group="'+accordianData+'"].accordion-tab').css({"justify-content": "flex-start","padding": "0" });
    }
  });
  
    
  $(".personInfoContainer .set > a").on("click", function () {
    if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active");
    } else {
        $(".set > a").parent().removeClass("active");
        $(this).parent().addClass("active");
    }
    $('.icon-plus').toggleClass('icon-minus');
  });
  if ($(window).width() < 768) {
    $(".personInfoContainer .set:first-child > a").parent().addClass("active");
  }

  
});

fixedPtoductForm();

$(document).scroll(function(){
  fixedPtoductForm();
});

function fixedPtoductForm(){
  if($('.productSidebar').length > 0 && $(this).scrollTop() >= $('.productSidebar').offset().top - 20 && $('.productSidebarContent').height() <= $('.tabContentContainer').height() && $('.productSidebarContent').height() <= $(window).height()) {
    if($('.relatedPages').length > 0){
      if($(this).scrollTop() + $('.productSidebarContent').height() >= $('.relatedPages').offset().top - 90){
        $('.productSidebarContent').addClass('absoluteSidebar');
        $('.productSidebarContent').removeClass('fixedSidebar');
      }else{
        $('.productSidebarContent').addClass('fixedSidebar');
        $('.productSidebarContent').removeClass('absoluteSidebar');
      }
    } else if($('#shopify-section-product-recommendations-API').length > 0) {
      
      if($(this).scrollTop() + $('.productSidebarContent').height() >= $('#shopify-section-product-recommendations-API').offset().top - 90){
        $('.productSidebarContent').addClass('absoluteSidebar');
        $('.productSidebarContent').removeClass('fixedSidebar');
      }else{
        $('.productSidebarContent').addClass('fixedSidebar');
        $('.productSidebarContent').removeClass('absoluteSidebar');
      }
      
    }
    else{
      if($(this).scrollTop() + $('.productSidebarContent').height() >= $('.supplierSliderContainer').offset().top - 140){
        $('.productSidebarContent').addClass('absoluteSidebar');
        $('.productSidebarContent').removeClass('fixedSidebar');
      }else{
        $('.productSidebarContent').addClass('fixedSidebar');
        $('.productSidebarContent').removeClass('absoluteSidebar');
      }
    }
  } else {
    $('.productSidebarContent').removeClass('fixedSidebar');
    $('.productSidebarContent').removeClass('absoluteSidebar');
  }
}

$(document).on('click','.shogun-form-box-submit',function(){
  $('.shogun-form-field-error-msg').each(function(){
    var $this = $(this);
    var attr  = $this.attr('style');
    
    if (typeof attr !== 'undefined' && attr !== false) {
      $this.css('display','inline-flex');
    }
    
  });
});

$(document).on('click','.product-serie .modalButton',function(){
  $(this).removeClass('accordion-active');
});

$('.kurse-tab li a[href^="#"]').on('click',function (e) {
  e.preventDefault();
  var target = this.hash;
  var $target = $(target);
  $('html, body').stop().animate({
    'scrollTop': $target.offset().top - 100
  }, 400, 'swing', function () {
  });
});

$('.image-with-text-section .info.text-align--left .button').on('click',function (e) {
  var target = this.hash;
  if(target != ''){
    e.preventDefault();
    var $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top - 100
    }, 400, 'swing', function () {
    });
  }
});

$('.content-heading .true-arrow').on('click',function (e) {
 $(this).closest('.related-content-wrapper').removeClass('hidden');
});

$(window).scroll(function(){ 
  if ($(this).scrollTop() > 600) {
    $('#scroll').fadeIn(); 
  } else { 
    $('#scroll').fadeOut(); 
  } 
}); 
$('#scroll').click(function(){ 
  $("html, body").animate({ scrollTop: 0 }, '600'); 
  return false; 
});
function getFormData($form){
  var unindexed_array = $form.serializeArray();
  var indexed_array = {};

  $.map(unindexed_array, function(n, i){
      indexed_array[n['name']] = n['value'];
  });
  return indexed_array;
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function formatDateString (date,format='regular',time='') {
  var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  var month = d.getUTCMonth()+1;
  var day = d.getUTCDate();
  var dayname = days[d.getUTCDay()];
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = '0' + month;
  }
  
  var min = '',
      h = '',
      dt = '',
      mt = '',
      tm = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  if(month < 10){
  	mt = 0;
  }
  if(time=='false'){
    tm = '';
  }else{
    // tm = ', '+h+hour+':'+min+minute;
    tm = ', '+newTime[0]+':'+newTime[1];
  }
  return (dayname+', '+dt+day+'.'+ mt+month+'.'+ year+tm);
}

const formatDate = (date,syear='true') => {
  const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  var month = (monthNames[d.getUTCMonth()]).toString();
  var day = d.getUTCDate().toString();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = '0' + month;
  }

  var min = '',
    h = '';
  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(syear == 'false'){
    year = newTime[0]+':'+newTime[1];
  }
  
  return (day+'. '+month+' '+ year);
}

function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}


// academy js
$(document).ready(function(){
  $(".shg-category .shg-category-row.stacked").addClass( "owl-carousel" );
  $(window).on("load resize",function(e){
    if ($(window).width() < 767){
         $('.shg-category .shg-category-row.stacked').owlCarousel({
           loop:false,
            margin:10,
            nav:false,
            responsive:{
                0:{
                    items:1,
                  dots:true,
                },
                600:{
                    items:2,
                  dots:true,
                },
                768:{
                    items:3,
                  dots:false,
                }
            }
          });
    }
  });

  function getIds(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
      return match[2];
    } else {
      return 'error';
    }
  }

  /*if($('.video-container').length>0){
    $('.video-container').each(function(){
      
      var $this = $(this)
      var url = $this.text();
      if(url!=''){
        var videoId = getIds(url.trim());
        if(videoId!='error'){
          var iframeMarkup = '<iframe width="560" height="315" src="//www.youtube.com/embed/' 
          + videoId + '" frameborder="0" allowfullscreen></iframe>';
          $this.html(iframeMarkup);
        }
        else{
          var iframeMarkup = '<video controls="controls" src="'+url+'"></video>';
          $this.html(url);
          var attr = $(this).siblings('.media-card-video').children('source').attr('src');
          
          if (typeof attr == 'undefined' || attr == ' ' ) {
              $(this).siblings('.media-card-video').remove();
          }
          
        }
      }
    });
  }*/


  $(".featured-collection__products .product-list").each(function(){
    var cources = $(this).find(".custom-class-slider");
    if(!cources.length){
      return;
    }
    var courceslist = cources.sort(function(a,b){
      return parseInt($(a).attr("data-index")) - parseInt($(b).attr("data-index"));
    });

    $(this).html(courceslist);
  });

});

